import React from 'react';
import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';

const MenuIcon = styled.img`
  width: 2rem;
  height: 2rem;
`;

const MenuLabel = styled.span`
  font-size: 1.2rem;
  margin-left: 0.3rem;
`;

const StyledMenuItem = withStyles({
  root: {
    color: '#8395a7',
    '&:hover': {
      backgroundColor: '#f3c314',
      color: '#fff',
      opacity: 0.8,
    },
  },
})(MenuItem);

/*
 *   MenuItem Component
 *   Usage/s:
 *     Custom color for hovering with Icon and Defined Label
 * */
const CustomMenuItem = ({ menuIcon, iconAltText, menuLabel, disabled, handleClick }) => (
  <StyledMenuItem onClick={handleClick} disabled={disabled}>
    <MenuIcon src={menuIcon} alt={iconAltText} />
    <MenuLabel>{menuLabel}</MenuLabel>
  </StyledMenuItem>
);

export default CustomMenuItem;
